import tw, { styled } from 'twin.macro';
import { keyframes } from '@emotion/react';

const lazyloader = keyframes`
0% { background: rgba(0, 0, 0, 0.05)}
30% { background: rgba(0, 0, 0, 0.05)}
40% { background: rgba(0, 0, 0, 0.05)}
100% { background: rgba(0, 0, 0, 0.05)}
`;

export const MainfieldWrapper = styled.div`
  font-family: var(--formFontType, Circular Std) !important;
  font-size: var(--formFontSize);
`;

export const FieldWrapper = styled.div`
  ${tw`my-3 relative`};

  font-family: var(--formFontType, Circular Std) !important;
  font-size: var(--formFontSize);

  @media (max-width: 576px) {
    display: block;
  }

  ${({ notInBuilder }) =>
    notInBuilder &&
    `
      margin-top: 0;
      margin-bottom: 0;
    `}
`;

export const Field = styled.div`
  ${tw`m-0 clear-both`};
  &.side-by-side {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    @media (max-width: 576px) {
      display: block !important;
    }
  }

  &.side-by-side.scale-rating {
    align-items: center;
  }

  :last-child {
    margin-bottom: 0;
  }

  outline: none;
  border: none;

  @media (max-width: 576px) {
    display: block !important;
  }
`;

export const InputWrapper = styled.div`
  ${tw`flex items-center mt-2`}
  word-wrap: break-word;

  &.side-by-side {
    flex: 0 0 70%;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 0;
    & [type='tel'] {
      font-family: var(--formFontType, Circular Std) !important;
      color: var(--formFieldColor, var(--formTextColor));
    }
  }

  .intl-tel-input {
    ${tw`w-full  mx-0 outline-none py-3.5 px-6 text-base bg-white border border-solid border-fieldGray rounded`}
    font-family: 'Inter' !important;

    .country-name {
      font-family: var(--formFontType) !important;
    }

    :focus {
      border-color: #85b7d9;
    }

    #fpls_iti {
      border: none;
      outline: none;
      background: transparent;
      width: 100%;
      padding-left: 30px !important;
      opacity: 0.65;
      font-family: var(--formFontType) !important;
    }

    &.fpls-iti-disabled {
      input.form-control {
        pointer-events: none;
      }
    }

    ${({ notInBuilder }) =>
      notInBuilder &&
      `
      border-color: var(--formFieldBorderColor, #DADADA);
      background: var(--formFieldBackgroundColor, #ffffff);
      font-family: var(--formFontType) !important;
      border-radius: var(--formFieldBorderRadius);
      color: var(--formFieldColor, var(--formTextColor));
    `}
  }

  > div.rating {
    margin-left: 0;
  }

  ${({ full }) =>
    full &&
    `
    > div[data-testid="rfs"] {
      width: 100%;
      padding: 0;

      > ul {
        border: 1px solid #85b7d970 !important;
        border-bottom-right-radius: 3px !important;
        border-bottom-left-radius: 3px !important;

        > li > span > span {
          font-size: 14px;
          font-family: var(--formFontType) !important;
        }
        
        > div > input {
          height: 35px;
          border: 1px solid #999 !important;
          outline: none !important;
          border-radius: 2px !important;
          font-size: 14px;
          font-family: var(--formFontType) !important;
        }
      } 
      
      
    }
  `}

  & #rfs-btn {
    ${tw`w-full outline-none text-base border border-solid border-fieldGray rounded opacity-70`}
    font-size: 14px !important;
    padding: 0.5rem;
    font-family: 'Inter' !important;

    &::after {
      border-top: 4px solid #888 !important;
      border-left: 4px solid transparent !important;
      border-right: 4px solid transparent !important;
      margin-right: 5px;
    }

    & span {
      font-family: 'Inter' !important;
      color: #999 !important;
      width: auto;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    ${({ notInBuilder }) =>
      notInBuilder &&
      `
    border-color: var(--formFieldBorderColor, #DADADA);
    background: var(--formFieldBackgroundColor) !important;
    border-radius: var(--formFieldBorderRadius);
    font-family: var(--formFontType) !important;
    color: var(--formFieldColor, var(--formTextColor));

    & span {
      font-family: var(--formFontType) !important;
      color: var(--formFieldColor, var(--formTextColor)) !important;
    }

    &:focus {
      border-color: #85b7d9;
    }
  `}

    :disabled {
      background-color: transparent;
    }
  }

  display: block;
`;

export const Input = styled.input`
  ${tw`w-full mx-0 outline-none py-3.5 px-6 text-base bg-white border border-solid border-fieldGray rounded opacity-70`};
  font-family: 'Inter' !important;

  ${({ notInBuilder }) =>
    notInBuilder &&
    `
    border-color: var(--formFieldBorderColor, #dadada);
    background: var(--formFieldBackgroundColor);
    font-family: var(--formFontType) !important;
    border-radius: var(--formFieldBorderRadius);
    color: var(--formFieldColor, var(--formTextColor));

    &:disabled {
      cursor: not-allowed;
    }
  `}

  ${({ inLabelledInput }) =>
    inLabelledInput &&
    `
    border: none !important;
    border-radius: 0 !important;
    opacity: 1;
  `}

  &:focus {
    border-color: #85b7d9;
  }

  ${({ left }) =>
    left &&
    `
    border-left: none;
    border-radius: 0;
    border: none;
  `}

  ${({ right }) =>
    right &&
    `
    border-right: none;
    border-radius: 0;
    border none;
  `}

  ${({ searchInput }) =>
    searchInput &&
    `
    background-image: url(https://storage.googleapis.com/fplsblog/search_icon.svg);
    background-position: 20px center;
    background-repeat: no-repeat;
    text-indent: 30px;
  `}
  
  &[type="checkbox"], &[type="radio"] {
    ${tw`cursor-pointer w-4.5 h-4.5 opacity-50`};
    accent-color: #1a8caf;

    &:checked {
      ${tw`opacity-100`};
    }
  }

  @media (max-width: 576px) {
    :not([type='checkbox']):not([type='radio']) {
      width: 100% !important;
    }
  }
`;

export const LabelWrapper = styled.div`
  ${tw`flex-1 flex items-start justify-between gap-2`};

  > label {
    ${tw`flex-1 font-normal text-base text-grey-light`};
    font-family: 'Circular Std' !important;
    word-wrap: break-word;

    ${({ notInBuilder }) =>
      notInBuilder &&
      `
      color: var(--formBodyLabelColor, var(--formTextColor));
      text-transform: var(--formLabelTransform);
      font-size: var(--formFontSize);
      font-family: var(--formFontType) !important;
      font-weight: 500;
    `}

    &:after {
      ${(props) =>
        props.required &&
        `
        content : '*';
        margin: -.2em 0 0 .2em;
        color: #db2828;
      `}
    }
  }

  &.side-by-side {
    flex: 0 0 28%;
    align-self: flex-start;
    margin-bottom: 0;
  }

  padding: ${(props) => props.pad || '0px'};
`;

export const PaymentNotice = styled.div`
  ${tw`flex w-full gap-2 p-2`};
  border: 0.5px solid #fc830a;
  background: #fff1e3;
  border-radius: 3px;
  color: #252525;

  span {
    font-family: var(--formFontType, Circular Std) !important;
    font-size: var(--formFontSize, 0.875rem);
  }
`;

export const TextAreaWrapper = styled.textarea`
  ${tw`w-full rounded m-0 py-3.5 px-6 bg-white outline-none border border-solid 
  border-fieldGray text-blackened text-base transition duration-100 ease-linear delay-0 overflow-auto opacity-70
 `}
  font-family: 'Inter' !important;
  resize: vertical;

  ${({ notInBuilder }) =>
    notInBuilder &&
    `
    border-color: var(--formFieldBorderColor, #dadada);
    background: var(--formFieldBackgroundColor);
    font-family: var(--formFontType) !important;
    border-radius: var(--formFieldBorderRadius);
    color: var(--formFieldColor, var(--formTextColor));

    &:disabled {
      cursor: not-allowed;
    }
  `}

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 20px;
  }

  :focus {
    border-color: #85b7d9;
  }

  ::placeholder {
    opacity: 0.6;
  }

  ::-ms-input-placeholder {
    opacity: 0.7;
  }

  height: 12em;
  min-height: 8em;
  max-height: 24em;

  @media (max-width: 576px) {
    width: 100% !important;
  }
`;

export const SubtextWrapper = styled.p`
  ${tw`italic mt-2 text-grey-lighter font-normal text-sm flex items-start justify-between gap-5`}
  font-family: 'Circular Std' !important;

  ${({ notInBuilder }) =>
    notInBuilder &&
    `
    font-family: var(--formFontType) !important;
    color: var(--formBodyLabelColor, var(--formTextColor));
    font-size: var(--formFontSize);
  `}

  &[style] {
    @media (max-width: 576px) {
      margin-left: 0 !important;
      padding-left: 0;
    }
  }

  span#words {
    font-family: inherit;
    font-size: inherit;
    color: inherit;
    white-space: nowrap;
  }
`;

export const FieldIcons = styled.div`
  display: none;
  @media (min-width: 769px) {
    &.active_edit {
      ${tw`flex justify-end mt-3.5 w-full`}
    }
  }
  @media (max-width: 769px) {
    display: none;
    &.hide_desktop {
      ${tw`flex justify-end gap-2 mt-3.5 w-full`}
    }
  }
  flex-wrap: wrap;
`;

export const IconWrapper = styled.button`
  ${tw`flex items-center`};
  outline: none;
  border: none;
  border-radius: 3px;
  background-color: rgba(0, 121, 150, 0.1);
  margin: 0 4px;
  padding: 5px;
  cursor: pointer;
  &:last-of-type {
    margin-right: 0;
  }
  & img {
    vertical-align: middle;
    height: 13px;
    width: 13px;
  }
  &:hover {
    background-color: rgba(0, 121, 150, 0.15);
  }
  ${({ del }) =>
    del &&
    `
    background-color: rgba(237, 76, 92, 0.1);
    &:hover {
      background-color: rgba(237, 76, 92, 0.15);
    }
  `}

  ${({ disable }) =>
    disable &&
    `
    opacity: 0.5;
    &:hover {
      cursor: not-allowed
    }
  `}

  .ui.dropdown {
    .menu {
      overflow: auto;
      max-height: 170px;

      & .text,
      .header,
      .item {
        color: #5b5656;
        ${tw`font-normal text-sm`}
        font-family: 'Inter' !important;
      }

      & .header {
        color: black;
      }

      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px #fff;
        border-radius: 10px;
        background-color: #fff;
      }

      &::-webkit-scrollbar {
        width: 2px;
        height: 2px;
        background-color: #fff;
      }
    }
  }
`;

export const IconText = styled.span`
  vertical-align: middle;
  margin-left: 0.5rem;
  color: #007996;
  font-weight: 500;
  font-size: 12px;
  font-family: 'Inter' !important;
  &.delete {
    color: #ed4c5c;
  }
  &.hide_mobile {
    display: none;
  }
`;

export const LabelHoverWrapper = styled.div`
  ${tw`flex flex-col`}
  @media (max-width: 512px) {
    .ctrl_wrapper &.mobile-active {
      border: 1px solid #0093b6;
      border-radius: 3px;
    }
  }
`;
export const RatingsWrapper = styled.div`
  ${tw`w-full`};
  > i.icon.star.empty:before {
    content: '\\f005';
  }
  > i.icon.empty:before {
    color: #4f4f4f;
    opacity: 0.7;
    font-weight: 300;

    ${({ notInBuilder }) =>
      notInBuilder &&
      `
      color: var(--formBodyLabelColor, var(--formTextColor));
    `}
  }
`;

export const RatingsIcon = styled.i`
  color: var(--formBodyLabelColor, var(--formTextColor));
  font-size: var(--formFontSize);
`;

export const MainChoiceWrapper = styled.div`
  ${tw` mb-3 w-full h-auto flex flex-col`}
  &.side-by-side {
    flex: 0 0 70%;
    align-items: flex-start;
  }
  &.inline {
    flex-flow: row wrap;
    justify-content: flex-start;
    & img {
      margin-left: 0 !important;
    }
    .choice-label {
      margin-left: 12px !important;
    }
  }
  > .ui.dropdown,
  > .ui.fluid.dropdown {
    margin-top: 8px;
    border: 1px solid #a4a4a4;
    opacity: 1;
    padding: 0.5rem;
    font-family: 'Circular Std' !important;
    ${({ notInBuilder }) =>
      notInBuilder &&
      `
      border-color: var(--formFieldBorderColor, #aaa);
      background: var(--formFieldBackgroundColor);
      font-size: var(--formFontSize);
      border-radius: var(--formFieldBorderRadius);
      font-family: var(--formFontType);
      color: var(--formFieldColor, var(--formTextColor));
    `}
  }

  > div span.text {
    font-family: 'Circular Std' !important;
    ${({ notInBuilder }) =>
      notInBuilder &&
      `
      font-size: var(--formFontSize) !important;
      font-family: var(--formFontType) !important;
    `}
  }

  > .ui.dropdown > .default.text,
  > .ui.fluid.dropdown > .default.text {
    color: #777 !important;
    opacity: 0.7;
    font-family: 'Circular Std' !important;
    font-size: 14px !important;
    ${({ notInBuilder }) =>
      notInBuilder &&
      `
      font-size: var(--formFontSize);
      font-family: var(--formFontType) !important;
    `}
  }

  > .ui.dropdown:not(.button) > .default.text,
  > .ui.default.dropdown:not(.button) > .text,
  > .ui.dropdown > .text,
  > .ui.fluid.dropdown > .text {
    padding: 0.5rem;
    font-family: 'Circular Std' !important;
    ${({ notInBuilder }) =>
      notInBuilder &&
      `
      font-size: var(--formFontSize);
      font-family: var(--formFontType) !important;
      color: var(--formFieldColor, var(--formTextColor));
    `}
  }
`;
export const RadioFieldsWrapper = styled.div`
  ${tw`mt-0 px-1`}
  border-radius: 3px;
  background-color: transparent;
  width: 100%;
  font-size: var(--formFontSize);
  border-radius: var(--formFieldBorderRadius);
  border-color: var(--formFieldBorderColor);

  &.inline {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;

    > div {
      min-width: 200px;
    }
  }
`;

export const RadioInput = styled.input`
  ${tw`cursor-pointer opacity-50 w-4.5 h-4.5`};
  accent-color: #1a8caf;

  &:checked {
    ${tw`opacity-100`};
  }
`;

export const RadioWrapper = styled.div`
  ${tw`py-0.5 my-3 relative`};
`;

export const RadioLabel = styled.label`
  ${tw`ml-2 mr-2 pl-7 block outline-none text-base opacity-70`}
  font-family: 'Circular Std' !important;
  color: #777;
  user-select: none;
  line-height: 15px;
  margin-top: -22px;

  ${({ notInBuilder }) =>
    notInBuilder &&
    `
    font-size: var(--formFontSize);
    color: var(--formBodyLabelColor, var(--formTextColor));
    text-transform: var(--formLabelTransform);
    font-family: var(--formFontType) !important;
  `}

  &.rtl {
    ${tw`pr-7 pl-0`};
  }
`;

export const ChoiceFieldLabel = styled.label`
  ${tw`text-base text-black font-normal relative`};
  font-family: 'Circular Std' !important;
  color: #777;

  ${({ notInBuilder }) =>
    notInBuilder &&
    `
    color: var(--formBodyLabelColor, var(--formTextColor));
    font-size: var(--formFontSize);
    font-family: var(--formFontType) !important;
  `}

  &.rtl {
    ${tw`pl-0`};
  }
`;

export const OptionWrappper = styled.div`
  ${tw`mb-2.5`}
  &.sm {
    width: 150px;
  }
  &.md {
    width: 200px;
  }
  &.lg {
    width: 330px;
  }
`;

export const ImageWrapper = styled.label`
  ${tw`flex flex-row relative items-center mt-1`}
`;

export const ImgCon = styled.div`
  ${tw`mx-3`};

  min-height: fit-content;
  max-height: fit-content;
  min-width: fit-content;
  max-width: fit-content;

  > img {
    height: 100%;
    width: 100%;
  }

  ${({ imgChoice }) =>
    imgChoice &&
    `
    flex: 0.9;
    min-height: initial;
    max-height: initial;
    min-width: initial;
    max-width: initial;
  `}

  & .lazyload-placeholder {
    animation: ${lazyloader} 2s linear infinite;
  }
`;

export const Img = styled.img`
  ${tw`w-full`};
`;

export const DescriptionField = styled.div`
  min-height: fit-content;
  background: transparent;
  padding: 5px;
  border-radius: 3px;
  font-family: 'Inter' !important;

  .pre-wrap {
    white-space: pre-wrap;
    font-family: 'Inter' !important;

    h1,
    h2,
    h3,
    h4,
    h5 {
      font-family: 'Inter' !important;
    }
  }

  ${({ notInBuilder }) =>
    notInBuilder &&
    `
    color: var(--formTextColor);
    font-family: var(--formFontType) !important;
   
    .pre-wrap {
      white-space: pre-wrap;
      font-family: var(--formFontType) !important;

      h1, h2, h3, h4, h5, strong {
        font-family: var(--formFontType) !important;
        font-weight: 500;
      }

      a {
        color: #4183c4;
        opacity: 0.9;
        text-decoration: underline;
  
        :hover {
          opacity: 1;
        }
      }

      strong {
        font-weight: 500;
      }

      ul {
        display: block;
        list-style-position: inside;
      }
  
      iframe {
        border: none;
        max-width: 100%;
      }
    }
  `}
  width: 100%;
`;

export const AddImageWrapper = styled.div`
  ${tw`flex justify-start w-full`};
  &.center {
    justify-content: center;
  }
  &.right {
    justify-content: flex-end;
  }
  & .lazyload-placeholder {
    ${tw`animate-lazyloader`}
  }
`;

export const ValidationWarning = styled.div`
  position: absolute !important;
  top: -37px !important;

  &.ui.label:before {
    left: 10px !important;
  }

  > span {
    font-family: var(--formFontType, Inter) !important;
    font-weight: 500;
  }
`;

export const PayButton = styled.button`
  color: #fff;
  background-color: ${({ bgColor }) => bgColor || '#444'};
  display: inline-block;
  font-weight: 600;
  line-height: 1.25;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  border-radius: 4px;
  padding: 1rem 8px;
  font-size: 14px;
  text-decoration: none;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  font-family: inherit;
  box-shadow: 0.5px 0.5px 1.5px 0 rgb(50 50 54 / 13%), 0 0 1.5px 0.5px rgb(63 63 68 / 5%);
  width: 100%;
  border: none;

  &.inQuickEditMode {
    width: 70%;
    margin-top: 2rem;
    margin-bottom: 1rem;
  }
`;

export const ModalPaymentButtonWrapper = styled.button`
  ${tw`w-full px-5 md:px-7 flex flex-col justify-center relative bg-white cursor-pointer outline-none border-none`};
  border: 0.5px solid rgba(170, 170, 170, 1);
  border-radius: 3px;
  min-height: 75px;

  .top {
    ${tw`w-full relative flex justify-between`};
    padding-bottom: ${({ hasBottomElement }) => (hasBottomElement ? '12px' : '24px')};
    padding-top: ${({ hasTopElement }) => (hasTopElement ? '12px' : '24px')};

    .merchant {
      color: rgba(37, 37, 37, 1);
      font-family: inherit;
      font-weight: 500;
      font-size: 16px;
    }

    .completed {
      ${tw`flex items-center gap-1`};
      color: rgba(40, 167, 68, 1);
      font-weight: 500;
      font-size: 12px;
    }

    .required,
    .optional {
      ${tw`absolute right-0 bottom-2`};
      font-style: italic;
      font-size: 12px;
    }

    .optional {
      color: rgba(134, 134, 134, 1);
    }
  }
`;

export const PayPalButtonWrapper = styled.div`
  ${({ isRenderedOnModal }) =>
    isRenderedOnModal &&
    `border: 0.5px solid rgba(170, 170, 170, 1);
    padding: 12px 1.75rem;
    position: relative;
    border-radius: 3px;

    @media (max-width: 320px) {
      padding: 12px 1.25rem;
    }

    .label {
      color: rgba(37, 37, 37, 1);
      margin-bottom: 1.25rem;
      font-family: inherit;
      font-weight: 500;
      font-size: 16px;
    }

    .required,
    .optional {
      background: transparent;
      position: absolute;
      font-style: italic;
      font-size: 12px;
      bottom: 0.5rem;
      right: 1.75rem;
      padding: 0;

      @media (max-width: 320px) {
        right: 1.25rem;
      }
    }

    .optional {
      color: rgba(134, 134, 134, 1);
    }
  `}
`;

export const FormPaymentFieldIndicator = styled.div`
  ${tw`w-full p-5 bg-white`}
  border: 0.5px solid rgba(170, 170, 170, 1);
  color: rgba(37, 37, 37, 1);
  font-family: inherit;
  border-radius: 3px;
  font-weight: 450;
  font-size: 14px;
`;

// ui state indicators
export const UiIndicator = styled.div`
  text-align: left;
  width: fit-content;
  padding: 3px 10px;
  margin: 5px 0;
  border-radius: 0.3rem;
  font-size: 12px;
  background-color: whitesmoke;
  border: 1px solid transparent;
  line-height: 1.2;

  > span {
    font-family: var(--fontFamily) !important;
  }

  &.mode {
    border: none;
    background-color: #eee;
  }

  &.paid {
    font-weight: 500;
    padding: 10px 15px;
    border-color: #bbb;
    color: green;
  }

  &.status {
    color: white;
    font-weight: 600;
    font-size: 10px;
  }

  &.status.green {
    background-color: #4e9f3d;
    border-color: #4e9f3d;
  }

  &.status.red {
    background-color: red;
    border-color: red;
  }
`;

export const FlexWrapper = styled.div`
  ${tw`flex gap-1.5 mt-1.5`}

  & button {
    background-color: transparent;
    & img {
      width: 100%;
    }
  }
`;

export const ClearRadioButtonWrapper = styled.button`
  ${tw`bg-transparent border-none outline-none cursor-pointer px-0 mt-2`};
  font-family: var(--formFontType) !important;
  font-size: var(--formFontSize, 12px);
  color: var(--formTextColor, #7d7c7c);
  line-height: 15px;
  font-weight: 500;
`;

export const EditHoverIconWrapper = styled.button`
  ${tw`flex items-center`};
  outline: none;
  border: none;
  background-color: rgba(0, 121, 150, 0.1);
  margin: 0 2px;
  border-radius: 3px;
  cursor: pointer;
  &:last-of-type {
    margin-right: 0;
  }
  &.icon {
    padding: 5px;
  }
  & img {
    vertical-align: middle;
    height: 13px;
    width: 13px;
  }
  &.row-icon {
    background: transparent;
    padding: 2px;
  }
  &:hover {
    background-color: rgba(0, 121, 150, 0.15);
  }
  ${({ del }) =>
    del &&
    `
    background-color: rgba(237, 76, 92, 0.1);
    &:hover {
      background-color: rgba(237, 76, 92, 0.15);
    }
  `}

  ${({ disable }) =>
  disable &&
  `
    opacity: 0.6;
    cursor: not-allowed;
  `}
`;